import React from 'react';
import { useDispatch } from 'react-redux';
import { useVisibilityObserver } from '@noths/polaris-client-react-hooks';
import {
  FavouriteButton,
  SolidButton,
  SolidButtonLink,
} from '@noths/polaris-client-ribbons-design-system';

import { FavouriteProduct } from 'src/redux/selectors';
import { sectionVisible } from 'src/redux/visibilityTracking';
import { ADD_TO_BASKET_CTA, BUY_GIFT_CARD_CTA, MAIN_PAGE_CTA_ID } from '../constants';
import { MAIN_PAGE_CTA_VISIBILITY_NAME } from '../tracking/events';
import * as styles from '../styles/ProductInfo.styles';

export interface AddToBasketButtonProps {
  product: FavouriteProduct;
  preventAddToBasketSubmit?: boolean;
  isLoading: boolean;
  onBuyGiftCard: VoidFunction;
  updateFavourite: (product: number) => void;
  submitPersonalisationForm: VoidFunction;
}

export const AddToBasketButton = ({
  product,
  preventAddToBasketSubmit = false,
  isLoading,
  onBuyGiftCard,
  updateFavourite,
  submitPersonalisationForm,
}: AddToBasketButtonProps) => {
  const dispatch = useDispatch();
  const { observedElementRef: mainPageCtaRef } = useVisibilityObserver(() =>
    dispatch(sectionVisible({ sectionName: MAIN_PAGE_CTA_VISIBILITY_NAME })),
  );

  return (
    <div ref={mainPageCtaRef} css={[styles.ctaSectionWrapper]}>
      <div css={styles.favouriteButtonWrapper}>
        <FavouriteButton
          css={styles.favouriteButton}
          onClick={() => updateFavourite(product.code)}
          active={product.isFavourited}
          size="large"
        />
      </div>
      {product.purchasable ? (
        <SolidButton
          type="submit"
          fullWidth
          css={styles.ctaButton}
          onClick={() => !preventAddToBasketSubmit && submitPersonalisationForm()}
          disabled={isLoading}
          id={MAIN_PAGE_CTA_ID}
          loading={isLoading}
        >
          {ADD_TO_BASKET_CTA}
        </SolidButton>
      ) : (
        <SolidButtonLink
          css={styles.ctaButton}
          fullWidth
          href="/gift-cards"
          id={MAIN_PAGE_CTA_ID}
          onClick={onBuyGiftCard}
        >
          {BUY_GIFT_CARD_CTA}
        </SolidButtonLink>
      )}
    </div>
  );
};
